// extracted by mini-css-extract-plugin
export default {"inicio":"inicio_inicio__OQh8p","welcomeCard":"inicio_welcomeCard__t9s+9","title":"inicio_title__QG1Sa","subtitle":"inicio_subtitle__+oYrk"};